module.exports = __webpack_public_path__ + "static/img/spinning-cogs.738b4ce1.svg";